import { Component, OnInit, Input } from '@angular/core';
import { DocumentService } from '../../../shared/web-api/document.service';

@Component({
    selector: 'app-document-link-viewer',
    templateUrl: './document-link-viewer.component.html',
    styleUrls: ['./document-link-viewer.component.scss']
})
export class DocumentLinkViewerComponent implements OnInit {
    @Input() model: app.models.WorkflowNodeAnchorModel;

    constructor(private documentService: DocumentService) { }

    ngOnInit() {
    }

    download() {
        this.documentService.download(this.model.documentId).subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/workflows/content-renderer/document-link-viewer/document-link-viewer.component.ts